var exports = {
  "p$": "FloatingPaneResizeHandles.module__handle___XzR3V3",
  "J3": "FloatingPaneResizeHandles.module__edgeTop___XzR3V3",
  "xf": "FloatingPaneResizeHandles.module__edgeBottom___XzR3V3",
  "Ve": "FloatingPaneResizeHandles.module__edgeLeft___XzR3V3",
  "IW": "FloatingPaneResizeHandles.module__edgeRight___XzR3V3",
  "wy": "FloatingPaneResizeHandles.module__cornerTopLeft___XzR3V3",
  "Ty": "FloatingPaneResizeHandles.module__cornerTopRight___XzR3V3",
  "AU": "FloatingPaneResizeHandles.module__cornerBottomLeft___XzR3V3",
  "pr": "FloatingPaneResizeHandles.module__cornerBottomRight___XzR3V3",
  "XX": "FloatingPaneResizeHandles.module__grip___XzR3V3",
  "eM": "FloatingPaneResizeHandles.module__gripMark___XzR3V3",
};

module.exports = exports;
